import EventBus from "../event-bus";
import {HOMEOWNER, HOME_SALE_SAVED_FAVORITE} from "./images";
import {BUY_TOUR, BUY_OFFER, BUY_ATTACH_FILES, BUY_CHAT, BUY_SAVE_SEARCH, } from "./images";
import {newProjectUrl} from "../components/helpers/externalRoutes";

export const SHOW_INTERSTITIAL_MODAL_EVENT = 'show-interstitial-modal-event';

export const INTERSTITIAL_MODAL_TYPES = {
    GET_STARTED: 'getStarted',
    GET_STARTED_SELL: 'getStartedSell',
    SAVE_FAVORITE: 'saveFavorite',
    SAVE_SEARCH: 'saveSearch',
    TOUR: 'tour',
    OFFER: 'offer',
    ATTACH_FILES: 'attachFiles',
    CHAT: 'chat',
    HOME_OWNERSHIP: 'homeowner'
};

export const interstitialModalContent = {
    [INTERSTITIAL_MODAL_TYPES.GET_STARTED]: {
        img: null,
        title: 'Get Started with %NAME%',
        subtitle: 'Let\'s set up a safe, secure place to collaborate and manage your home purchase or home sale.',
        buttonText: 'Continue',
    },
    [INTERSTITIAL_MODAL_TYPES.GET_STARTED_SELL]: {
        img: null,
        title: 'Get Started with %NAME%',
        subtitle: 'Let\'s set up a safe, secure place to collaborate and manage your home sale.',
        buttonText: 'Continue',
    },
    [INTERSTITIAL_MODAL_TYPES.SAVE_FAVORITE]: {
        img: HOME_SALE_SAVED_FAVORITE,
        title: 'Favorite Listings',
        subtitle: 'Let\'s set up a private collaboration hub to manage your home purchase.',
        buttonText: 'Continue',
    },
    [INTERSTITIAL_MODAL_TYPES.SAVE_SEARCH]: {
        img: BUY_SAVE_SEARCH,
        title: 'Save Searches & Get Alerts',
        subtitle: 'Let\'s set up a private collaboration hub to manage your home purchase.',
        buttonText: 'Continue',
    },
    [INTERSTITIAL_MODAL_TYPES.TOUR]: {
        img: BUY_TOUR,
        title: 'Schedule a Tour',
        subtitle: 'Let\'s set up a private collaboration hub to manage your home purchase.',
        buttonText: 'Continue',
    },
    [INTERSTITIAL_MODAL_TYPES.OFFER]: {
        img: BUY_OFFER,
        title: 'Start an Offer',
        subtitle: 'Let\'s set up a private collaboration hub to manage your home purchase.',
        buttonText: 'Continue',
    },
    [INTERSTITIAL_MODAL_TYPES.ATTACH_FILES]: {
        img: BUY_ATTACH_FILES,
        title: 'Attach Your Own Files & Photos',
        subtitle: 'Let\'s set up a private collaboration hub to manage your home purchase.',
        buttonText: 'Continue',
    },
    [INTERSTITIAL_MODAL_TYPES.CHAT]: {
        img: BUY_CHAT,
        title: 'Share, Ask Questions & Discuss',
        subtitle: 'Let\'s set up a private collaboration hub to manage your home purchase.',
        buttonText: 'Continue',
    },
    [INTERSTITIAL_MODAL_TYPES.HOME_OWNERSHIP]: {
        img: HOMEOWNER,
        title: 'Create Your Homeowner Hub',
        subtitle: '',
        buttonText: 'Continue',
    }
};

export function showInterstitialModal(
    modalType,
    userInfo,
    redirectQueryParams,
) {
    EventBus.$emit(
        SHOW_INTERSTITIAL_MODAL_EVENT,
        {
            type: modalType,
            userInfo: userInfo,
            img: interstitialModalContent[modalType].img,
            title: replacePlaceholders(
                interstitialModalContent[modalType].title,
                {"%NAME%": userInfo ? userInfo.firstName : 'unknown'}
            ),
            subtitle: interstitialModalContent[modalType].subtitle,
            buttonText: interstitialModalContent[modalType].buttonText,
            redirectLink: getRedirectLinkToNewProject(redirectQueryParams),
        }
    );
}

export function replacePlaceholders(string, replacements) {
    return string.replace(/%\w+%/g, function (placeholder) {
        return replacements[placeholder] || placeholder;
    });
}

export function getRedirectLinkToNewProject(redirectQueryParams) {
    const queryParams = {
        brandedLogin: window.brandedLogin,
    };

    for (const [key, value] of Object.entries(redirectQueryParams)) {
        if (value) {
            queryParams[key] = value;
        }
    }

    return newProjectUrl(queryParams);
}
